import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // icons
import Counselling from "../assets/Counselling.png";

const WhySection = () => {
  // Track which question is open
  const [openIndex, setOpenIndex] = useState(null);

  // FAQs
  const faqs = [
    {
      question: "Do you provide therapy for children or teens?",
      answer:
        "Yes, we provide counseling services for children, adolescents, and teens. Our therapists are trained to work with all age groups to ensure comfortable and effective communication.",
    },
    {
      question: "What if I need to cancel or reschedule?",
      answer:
        "You can easily reschedule or cancel your session by contacting support or using your booking dashboard. We recommend 24-hour notice for cancellations.",
    },
    {
      question: "Do I need any special equipment?",
      answer:
        "All you need is a stable internet connection and a device with a camera and microphone — such as a phone, tablet, or computer.",
    },
    {
      question: "What issues can I discuss in therapy?",
      answer:
        "You can discuss anxiety, depression, relationship issues, stress, trauma, or any personal concerns affecting your well-being.",
    },
    {
      question: "Can I take therapy from outside my country?",
      answer:
        "Yes! Our online sessions are available internationally, so you can connect with your therapist from anywhere in the world.",
    },
    {
      question: "How long is each session?",
      answer:
        "Typically, each therapy session lasts between 45–60 minutes depending on the session type and your therapist’s recommendation.",
    },
  ];

  // Toggle function
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white w-full py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">
          Why Online Counseling ?
        </h2>

        {/* Top Section: Text + Image */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 mb-20">
          {/* Text */}
          <div className="md:w-1/2">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Why Choose Online Therapy ?
            </h3>
            <p className="text-gray-600 leading-relaxed">
              In today’s fast-paced world, finding time for your mental
              well-being shouldn’t be difficult. Our online counseling sessions
              make it easy and safe to talk with a psychologist anytime, from
              anywhere.
            </p>
          </div>

          {/* Image */}
          <div className="md:w-1/2">
            <img
              src={Counselling}
              alt="Online counseling session"
              className="rounded-2xl w-full object-cover shadow-md"
            />
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-[#FFF0DC] rounded-2xl px-8 py-12 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900 mb-6">
            Frequently Asked Questions
          </h3>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm p-5 transition-all"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between text-left"
                >
                  <span className="font-medium text-gray-800">
                    {faq.question}
                  </span>
                  {openIndex === index ? (
                    <ChevronUp className="text-orange-500 w-5 h-5" />
                  ) : (
                    <ChevronDown className="text-orange-500 w-5 h-5" />
                  )}
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openIndex === index
                      ? "max-h-40 mt-3 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
